import {
   useState
  ,useEffect
} from 'external/react'

import {
   styled
  ,Box
  ,Fade
  ,Paper
} from 'external/material'

import {formatDuration, remainingSeconds} from 'external/date-fns'
import ExpiredMessage from './ExpiredMessage'
import useInterval from 'hooks/interval'
import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

 
const TimerContainer = styled(Paper)(timerStyles)

export default function Timer () {

  const {translate, language} = useTranslations()
  const {assessment = {}, assessmentLoaded} = useAssessment()

  const [count, setCount] = useState(0)
  const [expired, setExpired] = useState(false)

  useInterval(() => {
    setCount(count - 1)
  }, count  > 0 ? 1000 : null)

  useEffect(() => {
    if (assessment.started) {
      setExpired(count <= 0)
    }
  }, [count])

  const duration = assessmentLoaded && formatDuration(assessment.duration, language)

  useEffect(()=>{
    if (assessment.started) {
      const remaining = remainingSeconds(assessment.started,  assessment.duration)
      setCount(remaining)
    }
  }, [assessment.started])

  return (
    <Fade in={assessmentLoaded}>
      <TimerContainer className="root">
        <Box className="countdown">
          {formatCountDown(count)}
        </Box>
        <Box className="duration">
          <Box className="durationLabel">{translate('assessment-duration')}:</Box>
          <Box>{duration}</Box>
        </Box>
        <ExpiredMessage isOpen={expired} />
      </TimerContainer>
    </Fade>
  )  

}

function formatCountDown (time) {
  const hours = Math.floor(time / 3600).toString().padStart(2,0)
  const minutes = Math.floor((time % 3600) / 60).toString().padStart(2,0)
  const seconds = Math.floor(time % 60).toString().padStart(2,0)
  return `${hours}:${minutes}:${seconds}`
}


export function timerStyles () {
  return {
    "&.root": {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 18,
      padding: 25,
      color: '#505163',
    },
    "& .countdown": {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '18pt',
      fontWeight: 'bold',
      color: '#1e4c97'
    },
    "& .duration": {
      marginTop: 10,
      fontSize: '9pt',
      display: 'flex'
    },
    "& .durationLabel": {
      marginRight: 3
    }
  }
}
